export const formatCurrencyAmount = (amount: number): string =>
  parseFloat(amount.toFixed(2)).toString();
